import {ModalBackdrop} from 'common/components/modal_backdrop';
import type {ReactNode} from 'react';

interface GateOverlayProps {
  children: ReactNode;
}

// Full-page non-dismissable gate overlay.
// Content stays in the DOM under the overlay so search crawlers can index it.
export function GateOverlay({children}: GateOverlayProps) {
  return (
    <ModalBackdrop
      className='bg-white/85 backdrop-blur-sm'
      zIndex={30}
      aria-label='Guide access required'>
      {children}
    </ModalBackdrop>
  );
}
